import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarAuroraLinkPreviewDto } from "../dto/solar-proposal-aurora.dto"
import { solarProposalAuroraService } from "../services/solar-proposal-aurora.service"

/**
 * What linking an Aurora design would bring in. Each fetch is an Aurora call,
 * so it runs only for a ref the administrator asked to preview, isn't
 * retried, and isn't kept once the link panel closes.
 */
export default function useSolarAuroraLinkPreview(
  proposalId: string,
  ref: string | null,
): UseQueryResult<SolarAuroraLinkPreviewDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.auroraLinkPreview(proposalId, ref ?? ``),
    queryFn: () =>
      solarProposalAuroraService.getLinkPreview(proposalId, ref ?? ``),
    enabled: ref !== null,
    retry: false,
    cacheTime: 0,
  })
}
